import React, { useState } from 'react'

import { Tab, Tabs } from '@mui/material'

import { TabPanel } from 'components/TabPanel'
import { Table } from 'components/table'

type AuditConfigItem = {
  config: any[]
  isLoading: boolean
  label: string
  type: string
  data?: any
  detailView?: (...args: any[]) => any
}

type AuditProps = {
  config?: AuditConfigItem[]
}

const Audit = ({ config }: AuditProps) => {
  const [tab, setTab] = useState(0)

  return (
    <div style={{ display: 'flex' }}>
      <Tabs onChange={(_, value) => setTab(value)} orientation="vertical" style={{ flexShrink: 0 }} value={tab}>
        {config?.map((item, index) => (
          <Tab aria-controls={`tabpanel-${index}`} id={`tab-${index}`} key={item.type} label={item.label} />
        ))}
      </Tabs>

      {config?.map((item, index) => (
        <TabPanel index={index} key={item.type} value={tab}>
          <Table
            config={item.config}
            data={item.data}
            hover
            loading={item.isLoading}
            renderDetailView={item.detailView}
            title={item.label}
          />
        </TabPanel>
      ))}
    </div>
  )
}

export default Audit
